<!-- promotions.vue -->
<template>
	<div class="ui-promotions-wrapper ui-detail-common" v-if="detailInfo && detailInfo.zhpromos && detailInfo.zhpromos.length > 0">
		<!-- header -->
		<div class="promotions-header header" v-on:click='openCombinationPromotionList()'>
			<div><h3>组合优惠</h3><span style="font-size: 12px;margin-left: 12px;">该商品共有{{ detailInfo.zhpromos.length }}款组合优惠</span></div>
			<img src="../../../assets/image/change-icon/enter@2x.png">
		</div>
		<!-- 展示组合方案 -->
		<div class="promotions-body">
			<!-- <div class="body-list" v-for="(item, index) in detailInfo.zhpromos" :key="index">
        <span v-for="(goods, l) in item.goods_list" :key="l">
          <i>{{goods.goods_name}}</i>
          <img :src="goods.goods_thumb" alt="" srcset="">
          <i>+</i>
        </span>
			</div> -->
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
export default {
  data() {
    return {};
  },

  computed: {
    ...mapState({
      detailInfo: state => state.detail.detailInfo
    })
  },

  methods: {
    ...mapMutations({
      changePopstatus: 'changePopstatus'
    }),

    /*
				openCombinationPromotionList:
			*/
    openCombinationPromotionList() {
      if(window.sessionStorage.getItem("firstInto")=="true"){
        this.$router.push({'name': 'combinationPromotionList'});
			}else{
        this.$router.replace({'name': 'combinationPromotionList'});
			}
    }
  }
};
</script>

<style lang="scss" scoped>
.ui-promotions-wrapper {
  height: auto;
  &.ui-detail-common {
    padding: 0px;
  }
  .promotions-header {
    padding: 0px 15px;
    height: 50px;
    h3 {
      font-size: 16px;
      color: #333333;
    }
    img {
      width: 5px;
      height: 10px;
    }
  }
  .promotions-body {
    background: #FFFFFF;
    .body-list {
      border-top: 0.5px solid #E8EAED;
      padding: 0px 15px;
      height: 54px;
      line-height: 54px;
      display: flex;
      align-items: center;
      font-size: 16px;
      img {
        width: 50px;
        height: 50px;
      }
      span {
        font-size: 16px;
        color: #999999;
        margin-left: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/product-detail/child/CombinationPromotion.vue